(function () {
  'use strict';

  const instances = new Map();

  class MemberFaq {
    constructor(root) {
      this.root = root;
      this.tabs = Array.from(root.querySelectorAll('[data-member-faq-tab]'));
      this.panels = Array.from(root.querySelectorAll('[data-member-faq-panel]'));

      if (!this.tabs.length || !this.panels.length) return;

      this.onTabClick = this.onTabClick.bind(this);
      this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick));

      const initial =
        this.tabs.find((tab) => tab.classList.contains('is-active'))?.dataset.memberFaqTab ||
        this.tabs[0].dataset.memberFaqTab;
      this.activate(initial);
    }

    activate(tabKey) {
      this.tabs.forEach((tab) => {
        const on = tab.dataset.memberFaqTab === tabKey;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const on = panel.dataset.memberFaqPanel === tabKey;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });

      const activeTab = this.tabs.find((tab) => tab.dataset.memberFaqTab === tabKey);
      if (activeTab && window.matchMedia('(max-width: 768px)').matches) {
        activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    onTabClick(event) {
      const tab = event.currentTarget;
      const tabKey = tab.dataset.memberFaqTab;
      if (!tabKey) return;
      this.activate(tabKey);
    }

    destroy() {
      this.tabs.forEach((tab) => tab.removeEventListener('click', this.onTabClick));
    }
  }

  function initMemberFaq() {
    document.querySelectorAll('[data-member-faq]').forEach((root) => {
      const id = root.id;
      if (!id) return;

      if (instances.has(id)) {
        instances.get(id).destroy();
      }

      const instance = new MemberFaq(root);
      instances.set(id, instance);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMemberFaq);
  } else {
    initMemberFaq();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target.querySelector?.('[data-member-faq]')) return;
    initMemberFaq();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-member-faq]');
    if (!root?.id || !instances.has(root.id)) return;
    instances.get(root.id).destroy();
    instances.delete(root.id);
  });
})();
